import React, { useEffect, useState } from "react";
import { api, apiError } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { toast } from "sonner";

const PAY_META = {
  paid: { label: "Payé", cls: "border-green-500 text-green-600" },
  pending: { label: "En attente", cls: "border-amber-500 text-amber-600" },
  failed: { label: "Échec", cls: "border-destructive text-destructive" },
  expired: { label: "Expiré", cls: "opacity-70" },
};

export default function AdminPayments() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/admin/payments").then((r) => setItems(r.data)).catch((e) => toast.error(apiError(e)));
  }, []);

  const total = items.filter((t) => t.payment_status === "paid").reduce((s, t) => s + (t.amount || 0), 0);

  return (
    <div className="space-y-5" data-testid="admin-payments">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight">Paiements Stripe</h1>
          <p className="text-muted-foreground text-sm">{items.length} transaction(s) · {total.toLocaleString("fr-FR")} € encaissés</p>
        </div>
      </div>

      <Card className="p-0 rounded-md shadow-none overflow-hidden" data-testid="admin-payments-table">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Société</TableHead>
              <TableHead>Palier</TableHead>
              <TableHead className="text-right">Montant</TableHead>
              <TableHead>Statut</TableHead>
              <TableHead>Date</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {items.length === 0 && (
              <TableRow><TableCell colSpan={5} className="text-center text-muted-foreground py-8">Aucune transaction.</TableCell></TableRow>
            )}
            {items.map((t) => {
              const m = PAY_META[t.payment_status] || { label: t.payment_status, cls: "" };
              return (
                <TableRow key={t.session_id} data-testid={`admin-payment-row-${t.session_id}`}>
                  <TableCell className="font-medium">{t.company_name}<span className="block text-xs text-muted-foreground">{t.email}</span></TableCell>
                  <TableCell className="text-sm text-muted-foreground">{t.tier || "—"}</TableCell>
                  <TableCell className="text-right text-sm font-medium tabular-nums">{(t.amount || 0).toLocaleString("fr-FR")} {t.currency}</TableCell>
                  <TableCell><Badge variant="outline" className={m.cls}>{m.label}</Badge></TableCell>
                  <TableCell className="text-sm text-muted-foreground">{t.created_at ? new Date(t.created_at).toLocaleString("fr-FR") : "—"}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
}
